import AttendanceProfile from "./attendanceProfile";
export default AttendanceProfile;